module.exports = __webpack_public_path__ + "static/media/typeb1.2a671f0c.jpg";